import { render, staticRenderFns } from "./CreateDispatchLocation.vue?vue&type=template&id=4219b533&"
import script from "./CreateDispatchLocation.vue?vue&type=script&lang=ts&"
export * from "./CreateDispatchLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports